import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {IconContainerProps, ColorTheme} from "../types";

export const XIcon = (props: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const {colorTheme} = props;
  const isLight = colorTheme === ColorTheme.light;

  const AthletaSVG = (
    <svg fill="none" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M1.391 1.55603c-.585787.58579-.585786 1.53554 0 2.12133L8.71364 11 1.391 18.3226c-.585787.5858-.585786 1.5356 0 2.1214l.16503.165c.58579.5858 1.53554.5858 2.12133 0L11 13.2864l7.3226 7.3226c.5858.5858 1.5356.5858 2.1214 0l.165-.165c.5858-.5858.5858-1.5356 0-2.1214L13.2864 11l7.3226-7.32264c.5858-.58579.5858-1.53554 0-2.12133l-.165-.16503c-.5858-.585787-1.5356-.585786-2.1214 0L11 8.71364 3.67736 1.391c-.58579-.585787-1.53554-.585786-2.12133 0l-.16503.16503z"
        fill="#666"
        fillRule="evenodd"
      />
    </svg>
  );

  const BananaRepublicSVG = (
    <svg fill="none" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M.0340576 1.62505L1.62505.0340576 10.9058 9.31483 20.1866.0340576l1.591 1.5909924-9.2808 9.28075 9.2808 9.2808-1.591 1.591-9.2808-9.2808-9.28075 9.2808-1.5909911-1.591L9.31483 10.9058.0340576 1.62505z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );

  const GapSVG = (
    <svg viewBox="0 0 10.126 10.313" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="m9.213.187.913.913-9.211 9.212-.913-.913z"
          fill={isLight ? theme.color.wh : theme.color.b1}
        />
      </g>
      <g>
        <path
          d="m10.125 9.212-.912.913L0 .914.914 0z"
          fill={isLight ? theme.color.wh : theme.color.b1}
        />
      </g>
    </svg>
  );

  const OldNavySVG = (
    <svg fill="none" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M.0339966 1.62505L1.62499.0340576 10.9058 9.31483 20.1865.0340576l1.591 1.5909924-9.2807 9.28075 9.2807 9.2808-1.591 1.591-9.2807-9.2808-9.28081 9.2808-1.5909922-1.591L9.31477 10.9058.0339966 1.62505z"
        fill="#043863"
        fillRule="evenodd"
      />
    </svg>
  );

  const CrossBrandSVG = (
    <svg fill="none" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M.0339355 1.62505L1.62493.0340576 10.9057 9.31483 20.1865.0340576l1.591 1.5909924-9.2808 9.28075 9.2808 9.2808-1.591 1.591-9.2808-9.2808-9.28077 9.2808-1.5909932-1.591L9.31471 10.9058.0339355 1.62505z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: AthletaSVG,
    [Brands.BananaRepublic]: BananaRepublicSVG,
    [Brands.BananaRepublicFactoryStore]: BananaRepublicSVG,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: OldNavySVG,
    crossBrand: CrossBrandSVG,
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
